import React from "react";
import * as $store from "../../utils/store";
import { $storeLoaded } from "../../utils/store";
import { useStore } from "@nanostores/react";
import RadioPlayerPopup from "./radio";

function LoadStore() {
    const storeLoaded = useStore($storeLoaded);
    React.useEffect(() => {
        if (!storeLoaded) {
            $storeLoaded.set(true);
            for (const key in $store) {
                if (Object.hasOwnProperty.call($store, key) && $store[key].isLocalStorage) {
                    $store[key].restore()
                }
            }
        }
    }, [])

    return <></>
}

type BaseLayoutProps = {
    children?: React.ReactNode;
};

const BaseLayout: React.FC<React.PropsWithChildren<BaseLayoutProps>> = ({ children }) => {

    return (
        <>
            <LoadStore />
            <RadioPlayerPopup />
            {children}
        </>
    );
};

export default BaseLayout;
